import * as React from "react";
import { markdown, TableSpecimen } from "catalog";
import { Icon, Icons } from "./icons/index";
export default () => markdown `
## Icons
  ${(<TableSpecimen rows={Object.keys(Icons).map(k => ({
    Icon: <Icon name={k}/>,
    "Icon (2em)": (<p style={{ fontSize: "3em" }}>
            <Icon name={k}/>
          </p>),
    "Icon (colored)": (<p style={{ color: "rebeccapurple" }}>
            <Icon name={k}/> Lorem ipsum
          </p>),
    Name: k
}))}/>)}
`;



// WEBPACK FOOTER //
// ./src/theme/icons.docs.tsx